import React from "react";
import { Grid } from "@mui/material";

export const GridItem = ({ children, xs = 12 }) => {
    return (
      <Grid item xs={xs}>
        {children}
      </Grid>
    );
  };